// extracted by mini-css-extract-plugin
export default {"cardContainer":"AddDocument_cardContainer__IhEhu","header":"AddDocument_header__xl19u","body":"AddDocument_body__JK+r9","actions":"AddDocument_actions__ZjoQJ"};